import React from 'react';
import { CombinedFiltersSearchViewButton, CombinedFiltersSearchViewFiltersIconWrapper, CombinedFiltersSearchViewInputPlaceholder, CombinedFiltersSearchViewSelectedLocation, CombinedFiltersSearchViewSelectedLocations, CombinedFiltersSearchViewWrapper } from './styled';
import MapViewIcon from 'assets/svg/combined-filters-search-view/MapTrifold.svg';
import TreeIcon from 'assets/svg/combined-filters-search-view/Tree.svg';
import FiltersIcon from 'assets/svg/combined-filters-search-view/adjustments-horizontal.svg';
import SubheaderLocalData from 'components/local-data/subheader-local-data';
import SchoolIcon from 'assets/svg/graduation-cap.svg'; // @todo: ask Eviatar for the updated one
import { useLocale } from 'locale';
import { GetEntries } from '../MultiLocationSearch';
import { getEntryName } from 'utils/texts';
import FiltersView from 'components/filters';
import { useScreenBreakpoint } from 'consts/breakpoints';
import { FILTERS_BUTTON_ITEM } from 'components/filters/utils';

interface Props {
  setMobileMapViewActive: (isActive: boolean) => void;
}

export const CombinedFiltersSearchView: React.FC<Props> = props => {
  const { setMobileMapViewActive } = props;
  const { t } = useLocale();
  const breakpoint = useScreenBreakpoint();

  return (
    <CombinedFiltersSearchViewWrapper>
      <FiltersView
        screen="mobile"
        renderCustomMobileButton={(onClick, activeFiltersNumber) => (
          <GetEntries>
            {values => {
              const MAX_LOCATIONS_TO_DISPLAY = Math.min(breakpoint, 2);

              return (
                <CombinedFiltersSearchViewButton onClick={onClick} centeredContent={false} grow>
                  {values && values.length ? (
                    <CombinedFiltersSearchViewSelectedLocations>
                      {values.slice(0, MAX_LOCATIONS_TO_DISPLAY).map(entry => (
                        <CombinedFiltersSearchViewSelectedLocation key={entry.docId}>
                          {getEntryName(entry)}
                        </CombinedFiltersSearchViewSelectedLocation>
                      ))}
                      {values.length > MAX_LOCATIONS_TO_DISPLAY ? (
                        <CombinedFiltersSearchViewSelectedLocation>
                          +{values.length - MAX_LOCATIONS_TO_DISPLAY}
                        </CombinedFiltersSearchViewSelectedLocation>
                      ) : null}
                    </CombinedFiltersSearchViewSelectedLocations>
                  ) : (
                    <CombinedFiltersSearchViewInputPlaceholder>
                      {t('combinedSearchSubheader.searchInput.placeholder')}
                    </CombinedFiltersSearchViewInputPlaceholder>
                  )}
                  <CombinedFiltersSearchViewFiltersIconWrapper id={FILTERS_BUTTON_ITEM} hasActiveFilters={activeFiltersNumber > 0}>
                    <FiltersIcon />
                  </CombinedFiltersSearchViewFiltersIconWrapper>
                </CombinedFiltersSearchViewButton>
              );
            }}
          </GetEntries>
        )}
      />

      <SubheaderLocalData
        onlyIcon
        renderCustomMobileLabel={(isSchoolDoc) => (
          <CombinedFiltersSearchViewButton>
            {isSchoolDoc ? <SchoolIcon /> : <TreeIcon />}
          </CombinedFiltersSearchViewButton>
        )}
      />

      <CombinedFiltersSearchViewButton onClick={() => setMobileMapViewActive(true)}>
        <MapViewIcon />
      </CombinedFiltersSearchViewButton>
    </CombinedFiltersSearchViewWrapper>
  );
};

